// extracted by mini-css-extract-plugin
export default {"container":"Contact_container__QJ++1","left":"Contact_left__-kCuV","right":"Contact_right__v+kGr"};